import type {
  ArtShortSerializer,
  BasePaginationSerializer,
  FacetedArtsDataDTO,
  FastFacetedArtsDataDTO,
  PersonLightSerializer,
} from "../generated/foundation/api";

/* eslint-disable @typescript-eslint/naming-convention */
export interface ISearchPageState {
  query: string;
  appliedCorrection?: {
    from_query: string;
    to_query: string;
  } | null;
}

export interface ISearchResponse {
  error?: any; // в 200 приходит {}, надо будет уточнить кейсы у бэка, пока будет any
  status: number;
  payload: {
    extra: {
      applied_correction?: {
        from_query: string;
        to_query: string;
      };
      counters: Record<SearchResponseItemTypesEnum, number>;

      pagination: BasePaginationSerializer;
    };
    facets: FacetedArtsDataDTO[];
    fast_facets: FastFacetedArtsDataDTO[];
    data: TSearchAllItem[];
  };
}

interface ITopArts {
  id: number;
  title: string;
  url: string;
  cover_url: string;
  cover_ratio: number;
}

interface ITopGenres {
  id: number;
  name: string;
  url: string;
}

export enum PersonRoleEnum {
  author = "author",
  translator = "translator",
  agent = "agent",
  painter = "painter",
  compiler = "compiler",
  narrator = "narrator",
  reader = "reader",
  performer = "performer",
  vendor = "vendor",
  editor = "editor",
  actor = "actor",
  director = "director",
  producer = "producer",
  composer = "composer",
  sound_designer = "sound_designer",
  publisher = "publisher",
  screenwriter = "screenwriter",
  rights_holder = "rights_holder",
  layout_artist = "layout_artist",
  adaptation = "adaptation",
  dialogues = "dialogues",
  concept = "concept",
  review = "review",
  foreword = "foreword",
  afterword = "afterword",
  accompanists = "accompanists",
  citations = "citations",
  annotation = "annotation",
  related_to = "related_to",
  commentator = "commentator",
  consultant = "consultant",
  corrector = "corrector",
  scientific_advisor = "scientific_advisor",
  probable_author = "probable_author",
  designer = "designer",
  letter_recipient = "letter_recipient",
  sponsor = "sponsor",
  photographer = "photographer",
  other = "other",
  not_defined = "not_defined",
  chief_editor = "chief_editor",
  member_of_editorial_board = "member_of_editorial_board",
  responsible_editor = "responsible_editor",
  co_author = "co_author",
  illustrator = "illustrator",
  cover_designer = "cover_designer",
  lecturer = "lecturer",
  literary_processing = "literary_processing",
  comments = "comments",
  notes = "notes",
  text_preparation = "text_preparation",
}

export interface ISearchPerson {
  id: number;
  full_name: string;
  image_url: string | null;
  top_genres: ITopGenres[];
  top_arts: ITopArts[];
  arts_count: number;
  url: string;
  role: PersonRoleEnum;
  is_adult_content?: boolean;
}

export interface ISearchSeries {
  id: number;
  uuid: string;
  name: string;
  url: string;
  arts_count: number;
  top_arts: ITopArts[];
  top_persons?: PersonLightSerializer[];
  is_adult_content?: boolean;
}

export interface ISearchCollection {
  id: number;
  name: string;
  arts_count: number;
  url: string;
  top_arts: ITopArts[];
  is_adult_content?: boolean;
}

export interface ISearchGenreOrTag {
  id: number;
  uuid: string;
  name: string;
  url: string;
  arts_count: number;
  top_arts: ITopArts[];
  is_adult_content?: boolean;
}

export interface ISearchPublisher {
  id: number;
  title: string;
  url: string;
  small_cover_url: string;
  small_cover_ratio: number;
  arts_count: number;
  is_adult_content?: boolean;
}

// Возможно этот интерфейс надо будет шарить много где
// export interface IPagination {
//   next_offset: number;
// }

// TODO: выбрать более подходящий нейминг для этого енама, т.к. это уже не тип сущности, а все возможные срезы стора
// А лучше разделить тип сущности и срезы стора
export enum SearchResponseItemTypesEnum {
  all = "all",
  books = "books",
  person = "person",
  series = "series",
  tag = "tag",
  text_book = "text_book",
  audiobook = "audiobook",
  collection = "collection",
  genre = "genre",
  podcast_episode = "podcast_episode",
  podcast = "podcast",
  publisher = "publisher",
  books_filtered_by_libraries = "books_filtered_by_libraries",
}

interface ISearchItem {
  type: SearchResponseItemTypesEnum;
}

export interface ISearchPersonItem extends ISearchItem {
  type: SearchResponseItemTypesEnum.person;
  instance: ISearchPerson;
}

export interface ISearchSeriesItem extends ISearchItem {
  type: SearchResponseItemTypesEnum.series;
  instance: ISearchSeries;
}

export interface ISearchArtItem extends ISearchItem {
  type:
    | SearchResponseItemTypesEnum.text_book
    | SearchResponseItemTypesEnum.audiobook;
  instance: ArtShortSerializer;
}

export interface ISearchPodcastItem extends ISearchItem {
  type:
    | SearchResponseItemTypesEnum.podcast
    | SearchResponseItemTypesEnum.audiobook
    | SearchResponseItemTypesEnum.podcast_episode;
  instance: ArtShortSerializer;
}

export interface ISearchCollectionItem extends ISearchItem {
  type: SearchResponseItemTypesEnum.collection;
  instance: ISearchCollection;
}

export interface ISearchGenreOrTagItem extends ISearchItem {
  type: SearchResponseItemTypesEnum.genre | SearchResponseItemTypesEnum.tag;
  instance: ISearchGenreOrTag;
}

export interface ISearchPublisherItem extends ISearchItem {
  type: SearchResponseItemTypesEnum.publisher;
  instance: ISearchPublisher;
}

export type TSearchAllItem =
  | ISearchPersonItem
  | ISearchSeriesItem
  | ISearchArtItem
  | ISearchCollectionItem
  | ISearchGenreOrTagItem
  | ISearchPodcastItem
  | ISearchPublisherItem;
